import React, {Component, Fragment} from 'react';

import './UserDetails.css';

import { FormLabeledItem } from '../../components/FormUI';
import moment from 'moment';
import PatientService from '../../api/services/PatientService';
import { UserDetail } from '../../api/services/UserService';
import UserDetails from './UserDetails';
import ClientNotesView from './ClientNotesView';



export default class PhysicianDetails extends Component{
    render(){
        return(
            <UserDetails detailCard={PhysicianDetailCard} {...this.props} />
        )
    }
}

export class PhysicianDetailCard extends Component{
    state = {};

    componentDidMount(){
        if(this.props.clientId || this.props.user.clientId){
            this.loadPatient(this.props.clientId || this.props.user.clientId);
        }
    }

    loadPatient(id){
        PatientService.GetById(id).then((user)=>{
            console.log("User Details Loaded:", user)
            this.setState({user:user});
            if(this.props.onDetails){
                this.props.onDetails(user);
            }
        })
    }

    render(){

        let details = this.state.user || {};
        
        return(
            <Fragment>
            <div className='user-detail-card dr-detail-card table hmax align-top layout-fixed'>
                <div>
                    <div>
                        <h1>{details.fullName}</h1>
                        <FormLabeledItem label='Address'>
                            {details.address1}<br/>{details.address2}
                        </FormLabeledItem>
                        
                    </div>
                    <div>
                        <div className='table hmax align-top layout-fixed'>
                            <div>
                                <div>
                                    <FormLabeledItem label='Gender'>
                                        {details.gender}
                                    </FormLabeledItem>
                                    
                                </div>        
                                <div>
                                    <FormLabeledItem label='Speciality'>
                                        {details.typeOfWork}                                        
                                    </FormLabeledItem>
                                </div>                                                       
                            </div>
                            <div>
                                <div className='label'>Other Info</div>
                                <div></div>
                            </div>                                                         
                        </div>
                        <div className='table hmax layout-fixed other-info align-middle'>
                            <div>                                
                                <div>Home Phone</div>
                                <div>{details.homePhone}</div>
                            </div>
                            <div>
                                <div>Work Phone</div>
                                <div>{details.workPhone}</div>
                            </div>
                            <div>
                                <div>Cell Phone</div>
                                <div>{details.cellPhone}</div>
                            </div>
                            <div>
                                <div>Email</div>
                                <div>{details.email}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FormLabeledItem label='Notes'>
                <ClientNotesView clientId={details.clientId} />
            </FormLabeledItem>
            </Fragment>
            
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/Clients/PhysicianDetails.js